import { PlansDataRoutePath, PlansDataRouteType } from "routes/data-routes/billing-data/plans/route.meta";
import { ExtractFetcherDataType } from "routes/data-routes/types";
import { useFetcherData } from "v2/hooks/useFetcherData";
import { FetcherKeys } from "routes/dataroutes/Fetchers";


type HookReturnType = ReturnType<NonNullable<PlansDataRouteType["useAllPlans"]>>;
type FetcherDataType = ExtractFetcherDataType<HookReturnType>;

export function useAllPlans(): HookReturnType {
  const { value, error, fetcher, reload } = useFetcherData<FetcherDataType>({
    fetcherKey: FetcherKeys.PLANS,
    fetcherHref: PlansDataRoutePath,
    reloadOnFocus: true,
    reloadOnAuthenticationChange: false // plans data is the same for everyone
  });

  return {
    allPlans: value?.allPlans,
    allPlansError: error,
    allPlansFetcher: fetcher,
    reloadAllPlans: reload
  };
}
